export default {
  lang: {
    reset: 'កំណត់ ឡើង វិញ',
    search: 'តម្រង',
    expand: 'ពង្រីក',
    collapse: 'ស្មើ',
  },
};
